"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetSmtpTemplateOverviewSender {
    static getAttributeTypeMap() {
        return GetSmtpTemplateOverviewSender.attributeTypeMap;
    }
}
GetSmtpTemplateOverviewSender.discriminator = undefined;
GetSmtpTemplateOverviewSender.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    }
];
exports.GetSmtpTemplateOverviewSender = GetSmtpTemplateOverviewSender;
//# sourceMappingURL=getSmtpTemplateOverviewSender.js.map